module.exports = __webpack_public_path__ + "img/mz.4278b58a.svg";